(function () {
  'use strict';

  var itemSelectors = [
    '[class*="collection-image-grid-"][class$="__item"]',
    '[class*="best-sellers-tabs-"][class$="__item"]',
    '[class*="marking-solutions-"][class$="__card"]',
    '[class*="creations-masonry-"][class$="__item"]',
    '[class*="about-orion-"][class$="__counter"]',
    '[class*="about-orion-"][class$="__feature"]',
    '.contact-custom__left',
    '.contact-custom__right'
  ].join(',');

  var cardSelectors = [
    '[class*="collection-image-grid-"][class$="__card"]',
    '[class*="best-sellers-tabs-"][class$="__item"] .card-wrapper',
    '[class*="marking-solutions-"][class$="__card"]',
    '[class*="creations-masonry-"][class$="__item"]'
  ].join(',');

  function uniqueTopLevelItems(section) {
    return Array.from(section.querySelectorAll(itemSelectors)).filter(function (item, index, items) {
      return !items.some(function (parent, parentIndex) {
        return parentIndex !== index && parent.contains(item);
      });
    });
  }

  function prepareSection(section) {
    if (!section || section.dataset.homeReveal === 'ready') return;
    section.dataset.homeReveal = 'ready';

    uniqueTopLevelItems(section).forEach(function (item, index) {
      item.setAttribute('data-home-reveal-item', '');
      item.style.setProperty('--home-motion-order', Math.min(index, 7));
    });

    section.querySelectorAll(cardSelectors).forEach(function (card) {
      card.setAttribute('data-home-motion-card', '');
    });
  }

  function init(root) {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var sections = root && root.matches && root.matches('.shopify-section')
      ? [root]
      : Array.from(main.children).filter(function (element) {
          return element.classList && element.classList.contains('shopify-section');
        });

    sections.forEach(prepareSection);
    document.documentElement.classList.add('home-motion-ready');

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (section) { section.classList.add('is-home-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-home-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.08
    });

    sections.forEach(function (section, index) {
      if (index === 0 || section.getBoundingClientRect().top < window.innerHeight * 0.92) {
        requestAnimationFrame(function () { section.classList.add('is-home-visible'); });
      } else {
        observer.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
